import styled from '@emotion/styled';
import { forwardRef } from 'react';

import { animationFade } from '../../theme/animations/animationFade';
import { animationScaleFade2 } from '../../theme/animations/animationScaleFade';
import { cssUtil } from '../../theme/cssUtil';
import { su } from '../../theme/functions/su';
import { motion } from '../../theme/motion';

export function DeviceGrid() {}

DeviceGrid.Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

const DeviceGridItemBase = styled.div`
  flex: 0 0 auto;
  padding-inline-end: ${su(2)};
  padding-bottom: ${su(2)};

  &:not([data-animated='true']) {
    opacity: 0;
    animation-name: ${animationScaleFade2.in};
    animation-timing-function: ease-in-out;
    animation-duration: ${motion.duration.slow};
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
    animation-delay: var(--animation-delay);

    ${cssUtil.isReducedMotion} {
      opacity: 1;
      animation-name: ${animationFade.in};
      animation-delay: initial;
    }
  }
`;

function handleDeviceGridItemAnimationEnd(event) {
  event.currentTarget.setAttribute('data-animated', 'true');
}

DeviceGrid.Item = forwardRef(function DeviceGridItem(
  { onAnimationEnd = handleDeviceGridItemAnimationEnd, ...props },
  ref,
) {
  return <DeviceGridItemBase ref={ref} onAnimationEnd={onAnimationEnd} {...props} />;
});
